export default class CountRegister {
  private _read: number;
  private _unread: number;

  constructor(read: number, unread: number) {
    this._read = read;
    this._unread = unread;
  }

  get read(): number {
    return this._read;
  }

  get unread(): number {
    return this._unread;
  }

  public copyWith({
    read,
    unread,
  }: {
    read?: number;
    unread?: number;
  }): CountRegister {
    return new CountRegister(read ?? this._read, unread ?? this._unread);
  }

  static fromFirestoreMap(data: Record<string, any>): CountRegister {
    return new CountRegister(data.read, data.unread);
  }
}
